<template>
  <div >
    <slot />
  </div>
</template>

<script>
import config from '../../../../q-config'

export default {
  name: 'QMain',

  mixins: [config],

  componentName: 'QMain',

  computed: {},
  methods: {}
};
</script>

<style scoped>
.main-panel {
  padding: 10px;
}
</style>
